import { shouldHandleWithErrorView } from '../../error/errorUtils';
import { ERROR_PATH, HOME_PATH } from '../routeNames';
import { ReactRouterLocationState } from '../../appTypings';
import { AuthError, LoginApiError5xx, NotFoundError } from '../../error/errors';
import { getLoginRoutePath } from '../getRoutePath';

export default function getErrorRedirect(
  error: unknown
): { pathname: string; state?: ReactRouterLocationState } | undefined {
  if (!(error instanceof Error)) {
    return;
  }

  if (shouldHandleWithErrorView(error)) {
    return {
      pathname: `/${ERROR_PATH}`,
      state: {
        error: {
          name: error.name,
          sessionCookie:
            'sessionCookie' in error
              ? (error.sessionCookie as string)
              : undefined,
          userId: 'userId' in error ? (error.userId as string) : undefined,
        },
      },
    };
  } else if (error instanceof AuthError) {
    return { pathname: getLoginRoutePath() };
  } else if (error instanceof NotFoundError) {
    return {
      pathname: HOME_PATH,
    };
  } else if (error instanceof LoginApiError5xx) {
    return { pathname: HOME_PATH };
  }
}
